import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { branchActions as actions, notificationActions } from '../actions';
import { branchService } from '../services';


/* Get All Branch Sagas*/
function* handleGetAllBranchRequest() {
    const action = yield take(actions.getAllBranchesRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(branchService.getAllBranches, dataParams);

        if (res.isError) {
            yield put(actions.getAllBranchesError(res));

        } else {
            yield put(actions.getAllBranchesSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllBranchesError());
    }
}


/* -----------Watchers------------- */
function* handleGetBranchWatcher() {
    yield takeEvery(
        actions.getAllBranchesRequest,
        handleGetAllBranchRequest,
    );
}

function* rootBranchSaga() {
    yield all([
        handleGetAllBranchRequest(),
        handleGetBranchWatcher(),
    ]);
}

export default rootBranchSaga;
